// extracted by mini-css-extract-plugin
export default {"OrderStatus":"OrderStatus_OrderStatus__OgStF","Closed":"OrderStatus_Closed__MEiLZ"};